<template lang="pug">
  .text-center
    #liveshopping-highlight-wrap(v-if="highlightItem")
      input#liveShoppingTill(type="hidden" v-model="advertisedTill")
      router-link(:to="{ name: 'Host', params: { name: `${highlightItem.Host.Url}` }, hash:`#${highlightItem.id}` }" style="text-decoration: none;" data-instant="")
        .row.no-gutters
          .col-12.col-sm-8.order-sm-2
            .ls-discount-badge(:style="`border-color:${highlightItem.CustomAttributes.HighlightImages.hex}`")
              .ls-discount-badge-inner(:style="`background-color:${highlightItem.CustomAttributes.HighlightImages.hex}`")
                .ls-discount-badge-text
                  | -{{saving | formatPercentage}}
                  sup 2
            .ls-img-1(:style="`background-image: url(\"${highlightItem.CustomAttributes.HighlightImages.firstImage}large.jpg\")`")
          .col-12.col-sm-4.order-sm-1
            .row.no-gutters
              .col-6.col-sm-12
                .ls-img-2(:style="`background-image: url(\"${highlightItem.CustomAttributes.HighlightImages.secondImage}small.jpg\")`")
              .col-6.col-sm-12
                .ls-img-3(:style="`background-image: url(\"${highlightItem.CustomAttributes.HighlightImages.thirdImage}small.jpg\")`")
        .row
          .col-12
            .ls-colored-box.p-3(:style="`background-color:${highlightItem.CustomAttributes.HighlightImages.hex}`")
              .h1.txt-white.text-left {{headline}}
              .h2.txt-white.d-none.d-md-block.text-left {{subline}}
              hr
              .row
                .col-12.col-md-6
                  .countdown.txt-white.text-center.text-lg-left.pl-md-0.mb-0(style="margin:0 -5px")
                    FlipCountdown.txt-td-grey-basic(:deadline="advertisedTill" style="--counter-color:#fff;--label-color:#fff;")
                .col-12.col-md-6.mt-4.mt-md-0
                  .ls-price-box.txt-white
                    .ls-uvp.text-right
                      span {{highlightItem.RegularPrice | formatPrice}}
                      sup 1
                    .ls-vk.text-right
                      span jetzt&nbsp;
                      | {{highlightItem.CurrentPrice | formatPrice}}
        .text-center
          .small.d-inline-block.txt-td-grey-basic {{showLSQuantity}}

</template>

<script>
import moment from "moment";
import { calculateDiscount } from "@/lib/helper/math";
import FlipCountdown from "@/views/components/partials/countdown/FlipCountdown";
import { Items } from "@/graphql/Items.ts";

export default {
  name: "live-shopping-item",
  components: {
    FlipCountdown
  },
  apollo: {
    highlightItem: {
      query: Items.Queries.HighlightItem,
      loadingKey: "loading",
      fetchPolicy: "no-cache",
      result({ data }) {
        if (!data) {
          this.$log.warn("Es konnte kein Highlight geladen werden", data);
        }
      }
    }
  },
  computed: {
    headline() {
      const headline = this.highlightItem?.CustomAttributes?.Custom_LiveShopping_Headline || this.highlightItem?.Name;
      return headline?.trim();
    },
    subline() {
      return this.highlightItem?.CustomAttributes?.Custom_LiveShopping_Subline?.trim();
    },
    showLSQuantity() {
      if (this.highlightItem.Quantity > 10) {
        return "mehr als 10 verfügbar";
      } else if (this.highlightItem.Quantity <= 0) {
        return "ausverkauft";
      } else {
        return `noch ${this.highlightItem.Quantity} verfügbar`;
      }
    },
    advertisedTill() {
      return moment(this.highlightItem.AdvertisedTill).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    saving() {
      //return ((this.highlightItem.item.RegularPrice - this.highlightItem.item.CurrentPrice) / this.highlightItem.item.RegularPrice)*100
      return calculateDiscount(this.highlightItem);
    },
    hasViableHighlightItem() {
      return (
        !!this.highlightItem?.CustomAttributes?.HighlightImages && // don't draw if there are no images
        !!this.highlightItem?.Host?.Url && // don't draw if there is no url
        this.highlightItem.IsInLiveShopping // don't draw if item is not actually InLiveShopping todo: maybe handle this on backend
      );
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.ls-colored-box {
  border-radius: 0 0 10px 10px;
}
</style>
